export enum WorkflowState {
    ACTIVE = 'dashboard.workflows.workflow-item.states.active',
    DUE_SOON = 'dashboard.workflows.workflow-item.states.due_soon',
    OVERDUE = 'dashboard.workflows.workflow-item.states.overdue',
    COMPLETED = 'dashboard.workflows.workflow-item.states.completed'
}
